const staging = window.location.href.includes('admin.llt.kairoxlab.xyz');
const prod = window.location.href.includes('admin.lltraslados.com.ar');
const preprod = window.location.href.includes('admin-prod-llt.netlify.app');

// const staging = false;
// const prod = true;

const prodEnvs = {
  drivers: 'https://drivers.prod.llt.kairoxlab.xyz/api/v1',
  reservation: 'https://reservation.prod.llt.kairoxlab.xyz/api/v1',
  reservationApiKey:
    'SLl4trnJLt0jvBfu3er5Vt3WgMgun6dzsJIrrsN7baxAI9FHNfGqJJltxv',
  backEnd: 'https://back.lltraslados.com.ar/api/',
  booking: 'https://booking.prod.llt.kairoxlab.xyz/api/v1',
  pricing: 'https://pricing.prod.llt.kairoxlab.xyz/api/v1',
  pricingKeys: 'YgmUPthsFaXNDfQ2EzLltrJLjvBe5V76TbS4nt0pcGCdHkD1i0snwAWKS',
  matching: 'https://matching.prod.llt.kairoxlab.xyz/api/v1',
  matchingKeys: 'SLl4trnJLt0jvBfu3er5Vt376TS4nbS4nt0pcIm0rt4lGCdHkD1i0snwAWKS',
  notifications: 'wss://ws.prod.llt.kairoxlab.xyz/',
  travelTracker: 'https://tracking.lltraslados.com.ar/',
  export: 'https://exports.prod.llt.kairoxlab.xyz/api/v1',
  trafficLights: 'https://semaphore.prod.llt.kairoxlab.xyz/api/v1'
};

const stagingEnvs = {
  drivers: 'https://drivers.llt.kairoxlab.xyz/api/v1',
  reservation: 'https://reservation.llt.kairoxlab.xyz/api/v1',
  reservationApiKey: '5sBmgcl3eyDyWn5au6NpQ4NAWiWjR7eeMIbAvURkrlmQKSlpXUz',
  backEnd: 'https://api.llt.kairoxlab.xyz/api/',
  booking: 'https://booking.llt.kairoxlab.xyz/api/v1',
  pricing: 'https://pricing.llt.kairoxlab.xyz/api/v1',
  pricingKeys: 'YgmUPthsFaXNDfQ2EzLltrJLjvBe5V76TbS4nt0pcGCdHkD1i0snwAWKS',
  matching: 'https://matching.llt.kairoxlab.xyz/api/v1',
  matchingKeys: 'SLl4trnJLt0jvBfu3er5Vt3WgMgun6dzsJIrrsN7baxAI9FHNfGqJJltxv',
  notifications: 'wss://ws.llt.kairoxlab.xyz/',
  travelTracker: 'https://qa-llt-travel-tracker.netlify.app/',
  export: 'https://exports.llt.kairoxlab.xyz/api/v1',
  trafficLights: 'https://semaphore.llt.kairoxlab.xyz/api/v1'
};

const localEnvs = {
  drivers: 'https://drivers.llt.kairoxlab.xyz/api/v1',
  reservation: 'https://reservation.llt.kairoxlab.xyz/api/v1',
  reservationApiKey: '5sBmgcl3eyDyWn5au6NpQ4NAWiWjR7eeMIbAvURkrlmQKSlpXUz',
  backEnd: 'http://localhost:8000/api/',
  booking: 'http://localhost:8001/api/v1',
  pricing: 'http://localhost:8001/api/v1',
  pricingKeys: 'YgmUPthsFaXNDfQ2EzLltrJLjvBe5V76TbS4nt0pcGCdHkD1i0snwAWKS',
  matching: 'https://matching.llt.kairoxlab.xyz/api/v1',
  matchingKeys: 'SLl4trnJLt0jvBfu3er5Vt3WgMgun6dzsJIrrsN7baxAI9FHNfGqJJltxv',
  notifications: 'https://ws.llt.kairoxlab.xyz/',
  travelTracker: 'https://qa-llt-travel-tracker.netlify.app/',
  export: 'https://exports.llt.kairoxlab.xyz/api/v1',
  trafficLights: 'https://semaphore.llt.kairoxlab.xyz/api/v1'
};

//this is the line
// const env = prod ? prodEnvs : staging ? stagingEnvs : localEnvs;

const env = prod || preprod ? prodEnvs : true ? stagingEnvs : localEnvs;

export default env;
